import { Injectable } from '@angular/core';
import { IUserDataSnapshot } from '@core/models/user.models';
import { fetchAuthSession } from 'aws-amplify/auth';
import { from, type Observable, of } from 'rxjs';
import { catchError, map, shareReplay } from 'rxjs/operators';

@Injectable({
	providedIn: 'root'
})
export class UserStateService {
	private readonly _userData$: Observable<IUserDataSnapshot> = from(fetchAuthSession()).pipe(
		map(session => ({ isSignedIn: Boolean(session.tokens) })),
		catchError(() => of({ isSignedIn: false })),
		shareReplay({ bufferSize: 1, refCount: false })
	);

	public get userData$(): Observable<IUserDataSnapshot> {
		return this._userData$;
	}
}
